var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnections(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91999 5.8C8.54937 7.62579 6.93517 9 5 9C2.79086 9 1 7.20914 1 5C1 2.79086 2.79086 1 5 1C6.93516 1 8.54937 2.37421 8.91998 4.2H16.1319C18.9332 4.2 19.9985 7.85833 17.6352 9.36225L7.22389 15.9876C6.21103 16.6321 6.66761 18.2 7.86813 18.2H15.9333L17.6467 15.3963C18.0366 14.7582 18.9633 14.7582 19.3533 15.3963L23.0702 21.4785C23.4774 22.1449 22.9979 23 22.2169 23H14.7831C14.0021 23 13.5226 22.1449 13.9298 21.4785L14.9556 19.8H7.86813C5.06687 19.8 4.00159 16.1417 6.36489 14.6377L16.7762 8.01239C17.789 7.36785 17.3324 5.8 16.1319 5.8H8.91999ZM5 7.4C6.32548 7.4 7.4 6.32548 7.4 5C7.4 3.67452 6.32548 2.6 5 2.6C3.67452 2.6 2.6 3.67452 2.6 5C2.6 6.32548 3.67452 7.4 5 7.4ZM18.5 17.0684L15.8529 21.4H21.1471L18.5 17.0684Z",
    fill: "#232D54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnections);
export default __webpack_public_path__ + "static/media/connections.6fa322e1fedee5fd19d224aaac90a0cf.svg";
export { ForwardRef as ReactComponent };